<template>
  <button
    data-trackuserevent="track"
    role="button"
    aria-label="App Button"
    class="relative duration-75 transform-gpu AppButton"
    :class="classList"
    :disabled="disabled"
    :id="id"
  >
    <span
      class="absolute top-0 bottom-0 left-0 right-0 z-10 flex flex-row items-center justify-center w-full space-x-1 bg-gray-500 border-gray-500 rounded"
      v-if="loading"
    >
      <div
        class="w-3 h-3 bg-white border-2 border-solid rounded-full border-jsNeutral-60 animate-ping"
        :style="{ 'animation-delay': `${n * 300}ms` }"
        :key="`dot-${n}`"
        v-for="n in 3"
      ></div>
    </span>
    <span class="pointer-events-none" ref="buttonText">
      <slot></slot>
    </span>
  </button>
</template>

<script lang="ts">
import { PropType, defineComponent, toRefs, computed } from 'vue'

type size = 'medium' | 'small' | 'large'
type type = 'solid' | 'line' | 'ghost'
type color = 'dark' | 'primary' | 'secondary' | 'green' | 'red'

export default defineComponent({
  name: 'AppButton',
  props: {
    size: {
      type: String as PropType<size>,
      default: 'medium',
    },
    type: {
      type: String as PropType<type>,
      default: 'solid',
    },
    color: {
      type: String as PropType<color>,
      default: 'primary',
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    loading: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    id: {
      type: String as PropType<string>,
    },
  },
  setup: props => {
    const { size, type, color, id } = toRefs(props)
    const classList = computed(() => {
      return `${size.value} ${type.value} ${color.value}`
    })

    return { classList }
  },
})
</script>
